import { mapActions, mapGetters, mapState } from 'vuex';
import { countriesMap } from './../helpers/countriesMap';
import { getRegistrationDate } from './../helpers/brands/functions';

const tenDlcMixin = {
  computed: {
    ...mapState('enums', ['fetchingAllTenDlcEnums', 'errorFetchingAllTenDlcEnums']),
    ...mapGetters('enums', [
      'tenDlcEnumsAreLoaded',
      'usecaseMap',
      'mnoMap',
      'campaignStatusMap',
      'verticalMap',
      'stockExchangeMap',
      'tmoBrandTierMap',
      'brandStatussMap',
      'brandRelationshipMap',
      'altBusinessIdTypeMap',
      'entityTypeMap',
      'standardUsecaseMap',
      'specialUsecaseMap',
      'initialSetupFees',
    ]),
  },
  async beforeMount() {
    if (this.tenDlcEnumsAreLoaded) return;
    await this.fetchTenDlcEnums({});
  },
  methods: {
    ...mapActions('enums', ['fetchTenDlcEnums']),
    getDisplays(value, key) {
      if (key === 'country') {
        return countriesMap[value].name;
      }
      if (key === 'entityType') {
        return this.entityTypeMap[value]?.label || '';
      }
      if (key === 'vertical') {
        return this.verticalMap[value]?.label || '';
      }
      if (key === 'brandRelationship') {
        return this.brandRelationshipMap[value]?.label || '';
      }
      if (key === 'altBusinessIdType') {
        return this.altBusinessIdTypeMap[value]?.label || '';
      }
      if (key === 'stockExchange') {
        return this.stockExchangeMap[value]?.label || '';
      }
      if (key === 'usecase') {
        return this.usecaseMap[value]?.label || '';
      }
      return value;
    },
    getUseCasePrice(value) {
      return this.usecaseMap[value]?.price || '';
    },
    getInitialSetupFees() {
      return this.initialSetupFees;
    },
    getRegistrationDate,
  },
};

export default tenDlcMixin;
